import React from "react";
import { Results } from "@usereactify/search";

type Props = Parameters<NonNullable<Parameters<typeof Results>[0]["renderError"]>>[0];

export const ResultsError: React.FC<Props> = () => (
  <div className="text-center py-20">
    <h3 className="block mb-4 h6">Error displaying products.</h3>
    <button className="btn btn-secondary" onClick={() => location.reload()}>
      Refresh Page
    </button>
  </div>
);
